"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimezone = exports.TimezoneFromTimezoneName = exports.makeTimezoneFromTimezoneName = exports.isTimezone = exports.Timezone = exports.CountryFromCountryCode = exports.Country = exports.CountryCode = exports.COUNTRY_CODES = exports.TimezoneName = exports.TIMEZONE_NAMES = void 0;
const Tz = __importStar(require("countries-and-timezones"));
const effect_1 = require("effect");
const NAMESPACE = 'Timezone';
/**
 * `Record` associating each {@link Tz.TimezoneName} to its corresponding {@link TzTimezone}
 */
const TIMEZONE_MAP = Tz.getAllTimezones({ deprecated: true });
/**
 * See {@link Tz.TimezoneName}
 */
exports.TIMEZONE_NAMES = effect_1.Struct.keys(TIMEZONE_MAP);
exports.TimezoneName = effect_1.Schema.Literal(...exports.TIMEZONE_NAMES).annotations({
    identifier: `${NAMESPACE}.TimezoneName`,
    examples: ['Australia/Sydney', 'Europe/Amsterdam', 'America/Chicago', 'Europe/London'],
});
/**
 * `Record` associating each {@link Tz.CountryCode} to its corresponding {@link TzCountry}
 */
const COUNTRY_MAP = Tz.getAllCountries({ deprecated: true });
/**
 * See {@link Tz.CountryCode}
 */
exports.COUNTRY_CODES = effect_1.Struct.keys(COUNTRY_MAP);
exports.CountryCode = effect_1.Schema.Literal(...exports.COUNTRY_CODES).annotations({
    identifier: `${NAMESPACE}.CountryCode`,
    examples: ['IT', 'NL', 'US'],
});
exports.Country = effect_1.Schema.Struct({
    id: exports.CountryCode,
    name: effect_1.Schema.NonEmptyString,
    timezones: effect_1.Schema.Array(exports.TimezoneName),
}).annotations({
    identifier: `${NAMESPACE}.Country`,
});
exports.Country.Encoded;
/**
 * Transform `Schema` to transform from any {@link CountryCode} to its corresponding {@link Country}
 */
exports.CountryFromCountryCode = effect_1.Schema.transform(exports.CountryCode, exports.Country, {
    strict: false,
    decode: countryCode => COUNTRY_MAP[countryCode],
    encode: effect_1.Struct.get('id'),
}).annotations({
    identifier: `${NAMESPACE}.CountryFromCountryCode`,
});
const TimezoneOffsetMinutes = effect_1.Schema.Int.annotations({
    identifier: `${NAMESPACE}.TimezoneOffsetMinutes`,
    description: 'Integer describing the number of minutes between 2 local timestamps',
    documentation: 'Observed range: [-840, +840] (inclusive)',
});
const TimezoneOffsetString = effect_1.Schema.String.pipe(effect_1.Schema.pattern(/^[-+]\d{2}:\d{2}$/)).annotations({
    identifier: `${NAMESPACE}.TimezoneOffsetString`,
    description: 'String describing the difference in hours and minutes between 2 local timestamps',
    documentation: 'Observed range: [-14:00, +14:00] (inclusive)',
    examples: ['-03:30', '+00:00', '+12:45'],
});
exports.Timezone = effect_1.Schema.Struct({
    name: exports.TimezoneName,
    countries: effect_1.Schema.Array(exports.CountryFromCountryCode),
    utcOffset: TimezoneOffsetMinutes,
    utcOffsetStr: TimezoneOffsetString,
    dstOffset: TimezoneOffsetMinutes,
    dstOffsetStr: TimezoneOffsetString,
    aliasOf: effect_1.Schema.optionalWith(exports.TimezoneName, { exact: true, nullable: true }),
    deprecated: effect_1.Schema.optionalWith(effect_1.Schema.Boolean, { exact: true }),
}).annotations({ identifier: `${NAMESPACE}.Timezone` });
exports.Timezone.Encoded;
exports.isTimezone = effect_1.Schema.is(exports.Timezone);
/**
 * Utility function to create a `Schema` that will transform from the provided {@link TimezoneName}s
 * to corresponding {@link Timezone}s
 */
const makeTimezoneFromTimezoneName = (timezoneNames) => effect_1.Schema.transform(effect_1.Schema.Literal(...timezoneNames), exports.Timezone.pipe(effect_1.Schema.filter((timezone) => timezoneNames.includes(timezone.name))), {
    strict: true,
    decode: timezoneName => TIMEZONE_MAP[timezoneName],
    encode: (_, { name }) => name,
});
exports.makeTimezoneFromTimezoneName = makeTimezoneFromTimezoneName;
/**
 * Transform `Schema` to transform from any {@link TimezoneName} to corresponding {@link Timezone}
 */
exports.TimezoneFromTimezoneName = effect_1.Schema.transform(exports.TimezoneName, exports.Timezone, {
    strict: true,
    decode: timezoneName => TIMEZONE_MAP[timezoneName],
    encode: effect_1.Struct.get('name'),
}).annotations({
    identifier: `${NAMESPACE}.TimezoneFromTimezoneName`,
});
const getTimezone = (timezoneName) => (0, effect_1.pipe)(TIMEZONE_MAP, effect_1.Struct.get(timezoneName), effect_1.Schema.decodeSync(exports.Timezone));
exports.getTimezone = getTimezone;
//# sourceMappingURL=timezone.js.map